import React, { useState } from "react";
// import values from "../../../../values";

import { Container } from "react-bootstrap";
import {
  BreadCrumb,
  Pagination,
  TableHeader,
  TableLoading,
  ResponsiveView,
} from "../../../../../../components";
import values from "../../../../../../values";
import { Components } from "./components";
import "./index.scss";
import Context from "../../../../../../context";
import { useTranslation } from "react-i18next";
import {ONLINE_PARENT_TRANSACTION} from "../../../../../../values/tableHeaders";

type Props = {
  rqData: any;
  showModalData: any;
};

const OnlineDriverTransactionScreen = (props: Props) => {
  const {
    requestOnlineDriverTransaction,
    setRequestOnlineDriverTransaction,
  } = React.useContext(Context.OnlineDriverTransactionScreen);

  const { t } = useTranslation();
  return (
    <section id="transactions-screen">
      <ResponsiveView.Row className="table-options-wrapper">
        <ResponsiveView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
        </ResponsiveView.Column>
        <ResponsiveView.Column extraLarge={6} large={6} medium={7} className="search-and-filter-wrapper">
          <Components.TimeFilter />
        </ResponsiveView.Column>
      </ResponsiveView.Row>
      <ResponsiveView.Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader headers={values.tableHeaders.ONLINE_PARENT_TRANSACTION}/>
            {props.rqData?.status === "loading" ? (<TableLoading />) : (<Components.Body data={props.rqData} />)}
          </table>
        </div>
        <div style={{display: "flex", justifyContent: "center", marginTop: "2rem", gap: "1rem"}}><div></div></div>
      </ResponsiveView.Container>
      {props.rqData?.status === "success" &&
        props.rqData?.data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={requestOnlineDriverTransaction?.page}
              totalPages={props.rqData?.data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestOnlineDriverTransaction({
                  ...requestOnlineDriverTransaction,
                  page: page,
                })
              }
            />
          </div>
        )}
    </section>
  );
};

export default OnlineDriverTransactionScreen;
